import { render, staticRenderFns } from "./socialBlock.vue?vue&type=template&id=812a53b8&scoped=true"
import script from "./socialBlock.vue?vue&type=script&lang=js"
export * from "./socialBlock.vue?vue&type=script&lang=js"
import style0 from "./socialBlock.vue?vue&type=style&index=0&id=812a53b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812a53b8",
  null
  
)

export default component.exports